<template>
  <el-menu
    ref="menuPrinciapl"
    :default-active.sync="activeLink"
    :mode="mode"
    :collapse="isCollapse"
    :unique-opened="true"
    background-color="transparent"
    class="main-navigation-menu"
    :class="{ 'nav-collapsed': isCollapse }"
    @select="goto"
  >
    <div class="el-menu-item-group__title" style="padding-top: 4px">
      <span>{{ $t("sidebar.apps") }}</span>
    </div>
    <!-- <el-menu-item index="/dashboard/cmi">
      <i class="mdi mdi-desktop-mac-dashboard"></i>
      <span slot="title">Dashboard</span>
    </el-menu-item> -->
    <!-- <el-menu-item index="/productivity">
      <i class="mdi mdi-bar-chart"></i>
      <span slot="title">Productividad Gerencial</span>
    </el-menu-item> -->

    <el-menu-item index="/">
      <i class="mdi mdi-buffer"></i>
      <span slot="title">{{ $t("sidebar.activity_flow") }}</span>
    </el-menu-item>

    <el-submenu index="/galleries" popper-class="main-navigation-submenu">
      <template slot="title">
        <img class="icons" src="@/assets/images/LogoMenu/Gallery.png" />
        <span>{{ $t("sidebar.galleries") }}</span>
      </template>
      <el-menu-item index="/galleries/social">
        <span slot="title">{{ $t("sidebar.social") }}</span>
      </el-menu-item>
      <el-menu-item index="/galleries/projects">
        <span slot="title">{{ $t("sidebar.projects") }}</span>
      </el-menu-item>
    </el-submenu>
    <el-menu-item index="/calendar">
      <img class="icons" src="@/assets/images/LogoMenu/schedule.png" />
      <span slot="title">{{ $t("sidebar.calendar") }}</span>
    </el-menu-item>

    <el-menu-item index="/our_company">
      <img class="icons" src="@/assets/images/LogoMenu/office.png" />
      <span slot="title">{{ $t("sidebar.our_company") }}</span>
    </el-menu-item>

    <el-menu-item index="/internal-requests">
      <div
        style="
          width: 100px !important;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div style="flex-grow: 2">
          <img class="icons" src="@/assets/images/LogoMenu/request.png" />
        </div>
        <div>
          <span slot="title">Mis Solicitudes</span>
        </div>
        <div style="margin-left: 6px">
          <el-badge
            :value="myRequestNewCount"
            v-show="myRequestNewCount > 0"
            type="danger"
          ></el-badge>
        </div>
      </div>
    </el-menu-item>

    <el-menu-item index="/cmi">
      <div
        style="
          width: 100px !important;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div style="flex-grow: 2">
          <img class="icons" src="@/assets/images/LogoMenu/career.png" />
        </div>

        <div>
          <span slot="title">Mis Objetivos</span>
        </div>
        <el-tooltip
          style="padding: 0px; margin: 0px"
          class="item"
          effect="dark"
          :content="tooltipContent"
          placement="right-start"
        >
          <div style="margin-left: 6px">
            <el-badge
              :value="GetTotalCount"
              type="success"
              v-show="GetTotalCount > 0"
            ></el-badge>
          </div>
        </el-tooltip>
      </div>
    </el-menu-item>

    <el-menu-item index="/documents">
      <!-- <i class="mdi mdi-file-document-outline"></i> -->
      <img class="icons" src="@/assets/images/LogoMenu/archive.png" />
      <span slot="title">{{ $t("sidebar.session-documents") }}</span>
    </el-menu-item>

    <el-menu-item index="/Agenda-maintenance">
      <img class="icons" src="@/assets/images/LogoMenu/agenda.png" />
      <span>{{ $t("sidebar.Diary") }}</span>
    </el-menu-item>

    <div class="el-menu-item-group__title" style="padding-top: 4px">
      <span>{{ $t("sidebar.modules") }}</span>
    </div>

    <el-menu-item index="/iso">
      <!--
      v-if="
        IsInRoles([roles.AuxiliarSoporteTécnico, roles.CEO, roles.SuperUsuario])
      "
    -->
      <img class="icons" src="@/assets/images/LogoMenu/iso.png" />

      <span slot="title">{{ $t("sidebar.iso") }}</span>
    </el-menu-item>

    <el-submenu
      index="/administration"
      popper-class="main-navigation-submenu"
      v-if="
        IsInRoles([
          roles.DirectorAdministrativo,
          roles.Legal,
          roles.CEO,
          roles.SuperUsuario
        ])
      "
    >
      <template slot="title">
        <img
          class="icons"
          src="@/assets/images/LogoMenu/project-management.png"
        />
        <span>{{ $t("sidebar.Administration") }}</span>
      </template>
      <el-menu-item
        v-if="
          IsInRoles([
            roles.CEO,
            roles.SuperUsuario,
            roles.DirectorAdministrativo
          ])
        "
        index="/administration"
      >
        <img class="icons" src="@/assets/images/LogoMenu/administrative.png" />
        <span slot="title">{{ $t("sidebar.Administration") }}</span>
      </el-menu-item>

      <el-menu-item
        index="/legal"
        v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
      >
        <img class="icons" src="@/assets/images/LogoMenu/Legal.png" />
        <span slot="title">{{ $t("sidebar.legal") }}</span>
      </el-menu-item>
    </el-submenu>

    <el-menu-item index="/employees/ModulosRRHH">
      <template slot="title">
        <img class="icons" src="@/assets/images/LogoMenu/division.png" />
        <span>{{ $t("sidebar.RRHH") }}</span>
      </template>
    </el-menu-item>

    <!-- Select of Finances Sidebar -->
    <el-submenu
      index="/finances"
      popper-class="main-navigation-submenu"
      v-if="
        IsInRoles([
          roles.Finanzas,
          roles.CEO,
          roles.SuperUsuario,
          roles.EncargadaCompras,
          roles.DirectorAdministrativo
        ])
      "
    >
      <template slot="title">
        <img class="icons" src="@/assets/images/LogoMenu/Finance.png" />
        <span>{{ $t("sidebar.finances") }}</span>
      </template>
      <el-menu-item
        index="/status"
        v-if="
          IsInRoles([
            roles.Finanzas,
            roles.CEO,
            roles.SuperUsuario,
            roles.DirectorAdministrativo
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.status") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/finances"
        v-if="
          IsInRoles([
            roles.Finanzas,
            roles.CEO,
            roles.SuperUsuario,
            roles.DirectorAdministrativo
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.accounting") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/purchases"
        v-if="
          IsInRoles([
            roles.Finanzas,
            roles.CEO,
            roles.SuperUsuario,
            roles.DirectorAdministrativo
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.purchases") }}</span>
      </el-menu-item>
    </el-submenu>
    <!--  tg menu will be commented  if them want to use it again uncomment -->
    <!-- <el-submenu v-if="IsInRoles([roles.CEO, roles.SuperUsuario])">
      <template slot="title">
        <img
          class="icons"
          src="https://img2.freepng.es/20180810/biz/kisspng-javascript-scalable-vector-graphics-logo-encapsula-javascript-le-ekran-grnts-almak-alpere-5b6dbeb48e4583.2854840415339189005828.jpg"
        />
        <span>{{ $t("sidebar.Technology") }}</span>
      </template>

      <el-menu-item index="/internal-requests">
        <span slot="title">Solicitudes Internas</span>
      </el-menu-item>

      <el-menu-item
        index="/Development"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.developing") }}</span>
      </el-menu-item>

      <el-menu-item
        index="/policies"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.Policies") }}</span>
      </el-menu-item>

      <el-menu-item index="/ceo/rdl-equipos">
        <span slot="title">Herramientas Soporte </span>
      </el-menu-item>

      <el-menu-item
        index="/internal-requests/kpislaInternal/kpi-per-support-internal"
      >
        <span slot="title">KPI SLA</span>
      </el-menu-item>

      <el-menu-item
        index="/internal-requests/kpislaInternal/kpi-per-satisfactions-internal"
      >
        <span slot="title">KPI Satisfaccion </span>
      </el-menu-item>

      <el-menu-item
        index="/internal-requests/kpislaInternal/Report-per-Responsable-internal"
      >
        <span slot="title">Reporte Internos </span>
      </el-menu-item>
    </el-submenu> -->

    <!-- Select of Operations And Technology Sidebar -->
    <el-submenu
      index="/Development"
      popper-class="main-navigation-submenu"
      v-if="
        IsInRoles([
          roles.CEO,
          roles.SuperUsuario,
          roles.TecnicoTaller,
          roles.Proyectos,
          roles.AuxiliarSoporteTécnico
        ])
      "
    >
      <template slot="title">
        <img class="icons" src="@/assets/images/LogoMenu/tecnologia.png" />
        <span>{{ $t("sidebar.operationsAndTechnology") }}</span>
      </template>
      <!-- <el-menu-item
        index="/Development"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.developing") }}</span>
      </el-menu-item> -->
      <el-menu-item
        index="/technical_support"
        v-if="
          IsInRoles([
            roles.AuxiliarSoporteTécnico,
            roles.CEO,
            roles.SuperUsuario
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.support") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/projects"
        v-if="
          IsInRoles([
            roles.AuxiliarSoporteTécnico,
            roles.CEO,
            roles.SuperUsuario
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.projects") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/workshop"
        v-if="
          IsInRoles([
            roles.AuxiliarSoporteTécnico,
            roles.CEO,
            roles.SuperUsuario
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.workshop") }}</span>
      </el-menu-item>
      <!-- <el-menu-item
        index="/Audit-transactions/Audit"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.audit_transactions") }}</span>
      </el-menu-item> -->

      <!-- <el-menu-item
        index="/infrastructure"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.infrastructure") }}</span>
      </el-menu-item> -->
      <!-- <el-menu-item
        index="/workshop"
        v-if="IsInRoles([roles.TecnicoTaller, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.workshop") }}</span>
      </el-menu-item> -->
      <!-- <el-menu-item
        index="/projects"
        v-if="IsInRoles([roles.Proyectos, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.projects") }}</span>
      </el-menu-item> -->
      <!-- <el-menu-item
        index="/vehicleview"
      >
        <span slot="title">{{ $t("sidebar.vehicleM") }}</span>
      </el-menu-item> -->
      <!-- <el-menu-item
        index="/Agenda-maintenance"
        v-if="
          IsInRoles([
            roles.CEO,
            roles.SuperUsuario,
            roles.TecnicoTaller,
            roles.Proyectos,
            roles.AuxiliarSoporteTécnico
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.agenda-maintenance") }}</span>
      </el-menu-item> -->
    </el-submenu>

    <!-- Select of Commercial Sidebar -->
    <el-submenu
      index="/sales"
      popper-class="main-navigation-submenu"
      v-if="
        IsInRoles([
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario,
          roles.CallCenter,
          roles.ServicioAlCliente,
          roles.Marketing
        ])
      "
    >
      <template slot="title">
        <img
          class="icons"
          src="@/assets/images/LogoMenu/informes-comerciales.png"
        />
        <span>{{ $t("sidebar.commercial") }}</span>
      </template>
      <el-menu-item
        index="/sales"
        v-if="
          IsInRoles([
            roles.SoporteVentas,
            roles.EjecutivoDeVentas,
            roles.CEO,
            roles.SuperUsuario,
            roles.ServicioAlCliente,
            roles.AnalistaDeMarketing,
            roles.Marketing
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.sales") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/call-center"
        v-if="IsInRoles([roles.CallCenter, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.call-center") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/customer_service"
        v-if="
          IsInRoles([roles.ServicioAlCliente, roles.CEO, roles.SuperUsuario])
        "
      >
        <span slot="title">{{ $t("sidebar.customer_service") }}</span>
      </el-menu-item>
      <el-menu-item
        index="/marketing"
        v-if="
          IsInRoles([
            roles.AnalistaDeMarketing,
            roles.Marketing,
            roles.CEO,
            roles.SuperUsuario
          ])
        "
      >
        <span slot="title">{{ $t("sidebar.marketing") }}</span>
      </el-menu-item>
    </el-submenu>

    <!-- Select of Ceo Sidebar -->
    <!-- <el-submenu index="/CEO" popper-class="main-navigation-submenu">
      <template slot="title">
        <img class="icons" src="@/assets/images/LogoMenu/CEO.png" />
        <span>CEO</span>
      </template>
    </el-submenu>
 -->

    <!--

    <el-menu-item
      index="/finances"
      v-if="IsInRoles([roles.Finanzas, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/Finance.png" />
      <span slot="title">{{ $t("sidebar.finances") }}</span>
    </el-menu-item> -->

    <!--
    <el-menu-item
      index="/call-center"
      v-if="IsInRoles([roles.CallCenter, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/SalesSupport.png" />

      <span slot="title">{{ $t("sidebar.call-center") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/sales"
      v-if="
        IsInRoles([
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario
        ])
      "
    >
      <img class="icons" src="@/assets/images/LogoMenu/Ventas.png" />

      <span slot="title">{{ $t("sidebar.sales") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/customer_service"
      v-if="IsInRoles([roles.ServicioAlCliente, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/ServicioAlCliente.png" />
      <span slot="title">{{ $t("sidebar.customer_service") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/technical_support"
      v-if="
        IsInRoles([roles.AuxiliarSoporteTécnico, roles.CEO, roles.SuperUsuario])
      "
    >
      <img class="icons" src="@/assets/images/LogoMenu/technical-support.png" />

      <span slot="title">{{ $t("sidebar.technical_support") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/workshop"
      v-if="IsInRoles([roles.TecnicoTaller, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/icons8-nailer-48.png" />
      <span slot="title">{{ $t("sidebar.workshop") }}</span>
    </el-menu-item> -->
    <!--
    <el-menu-item
      index="/purchases"
      v-if="IsInRoles([roles.EncargadaCompras, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/Compras.png" />
      <span slot="title">{{ $t("sidebar.purchases") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/projects"
      v-if="IsInRoles([roles.Proyectos, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/Project.png" />

      <span slot="title">{{ $t("sidebar.projects") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/marketing"
      v-if="
        IsInRoles([
          roles.AnalistaDeMarketing,
          roles.Marketing,
          roles.CEO,
          roles.SuperUsuario
        ])
      "
    >
      <img class="icons" src="@/assets/images/LogoMenu/Marketing.png" />

      <span slot="title">{{ $t("sidebar.marketing") }}</span>
    </el-menu-item> -->

    <!-- <el-menu-item
      index="/legal"
      v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
    >
      <img class="icons" src="@/assets/images/LogoMenu/Legal.png" />

      <span slot="title">{{ $t("sidebar.legal") }}</span>
    </el-menu-item> -->
    <!--
    <el-submenu
      index="/legal"
      popper-class="main-navigation-submenu"
      v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
    >
      <template slot="title">
        <img class="icons" src="@/assets/images/LogoMenu/Legal.png" />
        <span>{{ $t("sidebar.legal") }}</span>
      </template>
      <el-menu-item
        index="/legal"
        v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.legalall") }}</span>
      </el-menu-item>
      <!- <el-menu-item
        index="/legaltb"
        v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.legaltb") }}</span>
      </el-menu-item> -->
    <!-- <el-menu-item
        index="/legalMTR"
        v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.legalmtr") }}</span>
      </el-menu-item> -->
    <!-- <el-menu-item
        index="/legalRB"
        v-if="IsInRoles([roles.Legal, roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.legalrb") }}</span>
      </el-menu-item> ->
    </el-submenu>-->

    <el-submenu
      index="/Technology"
      popper-class="main-navigation-submenu"
      v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
    >
      <template slot="title">
        <img
          class="icons"
          src="https://img2.freepng.es/20180810/biz/kisspng-javascript-scalable-vector-graphics-logo-encapsula-javascript-le-ekran-grnts-almak-alpere-5b6dbeb48e4583.2854840415339189005828.jpg"
        />
        <span>{{ $t("sidebar.Technology") }}</span>
      </template>

      <el-menu-item
        index="/technology"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.development") }}</span>
      </el-menu-item>

      <el-menu-item
        index="/infrastructure"
        v-if="IsInRoles([roles.CEO, roles.SuperUsuario])"
      >
        <span slot="title">{{ $t("sidebar.infrastructure") }}</span>
      </el-menu-item>
    </el-submenu>

    <el-menu-item index="/CEO" v-if="IsInRoles([roles.CEO])">
      <img class="icons" src="@/assets/images/LogoMenu/CEO.png" />

      <!-- <span slot="title">{{ $t("sidebar.legal") }}</span> -->
      <span>CEO</span>
    </el-menu-item>
    <!--
    <el-menu-item
      index="/authorizer"
      v-if="IsInRoles([roles.AdministradorDeAuthorizador])"
    >
      <i class="el-icon-stopwatch"></i>
      <span>Administrador del Autirizador</span>
    </el-menu-item> -->

    <el-menu-item index="/automatic-processes">
      <img class="icons" src="@/assets/images/LogoMenu/Proceso.png" />
      <span>Aut. Processes</span>
    </el-menu-item>

    <el-menu-item index="/kpi">
      <img class="icons" src="@/assets/images/LogoMenu/KPI.png" />
      <span>KPI</span>
    </el-menu-item>
    <!-- <el-menu-item index="/historyjobs" >
      <img class="icons" src="@/assets/images/LogoMenu/history.png" />
      <span> {{ $t("sidebar.historyjobs") }} </span>
    </el-menu-item> -->
    <!-- <el-menu-item
      index="/Agenda-maintenance"

    >
      <img class="icons" src="@/assets/images/LogoMenu/agenda.png" />
      <span>{{ $t("sidebar.Diary") }}</span>
    </el-menu-item> -->
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";

import { detect } from "detect-browser";
const browser = detect();

export default {
  name: "Nav",
  props: ["mode", "isCollapse"],
  data() {
    return {
      isIe: true,
      isEdge: true,
      activeLink: null,
      peddingCount: 0,
      peddingCountMyRequest: 0
    };
  },
  computed: {
    ...mapGetters({
      GetTotalCount: "GetTotalCount",
      GetTaskTotalCount: "GetTaskTotalCount",
      GetObjectiveTotalCount: "GetObjectiveTotalCount",
      myRequestNewCount: "my_request/myRequestNewCount",
      getUserTypeInternalRequest: "my_request/getUserTypeInternalRequest"
    }),
    tooltipContent() {
      // console.log( `Total de Objetivo: ${this.GetObjectiveTotalCount} Total de tarea: ${this.GetTaskTotalCount}`);
      return `Total de Objetivo: ${this.GetObjectiveTotalCount} Total de tarea: ${this.GetTaskTotalCount}`;
    },
    setColorInBadgeCountRequestInNavBar() {
      var classToSet = "";
      let typeUser = this.getUserTypeInternalRequest;
      if (typeUser === "SUPERVISOR" || typeUser === "CEO") {
        classToSet = "danger";
      }
      if (typeUser === "RESPONSABLE") {
        classToSet = "warning";
      }
      if (typeUser === "CREADOR") {
        classToSet = "success";
      }
      return classToSet;
    }
  },
  methods: {
    loadObjetiveNotification() {
      //console.log("loadObjetiveNotification this: ", this)
      this.$store.dispatch("updateBadgetCount", this);
      // this.$http
      //   .get(
      //     `/api/CMI/Objetives/Pedding?ResponsableId=${this.currentUser.EmployeeId}`
      //   )
      //   .then(({ data }) => {
      //     if (data > 0) {
      //       this.$store.state.objectiveCount = data;
      //       this.peddingCount =this.$store.state.objectiveCount;
      //     } else {
      //       this.peddingCount = 0;
      //     }
      //   });
    },

    // loadObjetiveNotification() {
    //   this.$http
    //     .get(
    //       `/api/CMI/Objetives/Pedding?ResponsableId=${this.currentUser.EmployeeId}`
    //     )
    //     .then(({ data }) => {
    //       if (data > 0) {
    //         this.peddingCount = data;
    //       } else {
    //         this.peddingCount = 0;
    //       }
    //     });
    // },
    MyRequestCount() {
      this.$http
        .get(
          `/api/InternalServiceRequest/GetCountPenddingInternalServiceRequest/?userId=${this.currentUser.EmployeeId}&&company=${this.currentCompany}`
        )
        .then(({ data }) => {
          if (data > 0) {
            this.peddingCountMyRequest = data;
          } else {
            this.peddingCountMyRequest = 0;
          }
        });
    },
    // eslint-disable-next-line no-unused-vars
    goto(index, indexPath) {
      if (index.charAt(0) === "/") {
        this.$router.push(index).catch(() => {});
        this.$emit("push-page", { page: index });
      }
    },
    setLink(path) {
      this.activeLink = path;
    }
  },
  created() {
    if (browser.name !== "ie") this.isIe = false;
    if (browser.name !== "edge") this.isEdge = false;

    const mainActiveMenu = this.$store.getters.mainActiveMenu;
    if (mainActiveMenu) {
      this.setLink(mainActiveMenu);
    } else {
      this.setLink(this.$router.currentRoute.path);
    }

    // eslint-disable-next-line no-unused-vars
    this.$router.afterEach((to, from) => {
      try {
        this.setLink(to.matched[0].path);
      } catch (_) {
        //
      }
    });
    this.loadObjetiveNotification();
    this.MyRequestCount();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables";

.icons {
  width: 21.984px;
  height: 21.984px;
  margin-right: 10px;
}
.el-menu {
  border: none;
}
.el-menu::before,
.el-menu::after {
  display: none;
}
.el-submenu,
.el-menu-item {
  .mdi {
    vertical-align: middle;
    margin-right: 5px;
    display: inline-block;
    width: 24px;
    text-align: center;
    font-size: 18px;
  }
}
</style>

<style lang="scss">
@import "../assets/scss/_variables";

.main-navigation-menu {
  transition: width 0.5s;

  &:not(.el-menu--collapse) {
    .el-submenu__title,
    .el-menu-item {
      height: 40px;
      line-height: 40px;
      background-color: transparent !important;
    }

    &:not(.el-menu--horizontal) {
      .el-menu-item,
      .el-submenu {
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 0px;
          height: 1px;
          position: absolute;
          bottom: 10px;
          left: 30px;
          background: $text-color;
          z-index: 1;
          opacity: 0;
          transition: all 0.7s cubic-bezier(0.55, 0, 0.1, 1);
        }
        &:hover {
          &::before {
            width: 100px;
            opacity: 1;
            //left: 50px;
            transform: translate(20px, 0);
          }
        }

        &.is-active {
          &::before {
            background: $text-color-accent;
          }
        }
      }
    }

    .el-submenu.is-opened {
      //background: #edf1f6 !important;
      //background: rgba(223, 228, 234, 0.38) !important;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 2px;
        position: absolute;
        top: 40px;
        bottom: 10px;
        left: 31px;
        background: $text-color;
        z-index: 1;
      }

      &::before {
        display: none;
      }

      .el-menu-item,
      .el-submenu {
        &::before,
        &::after {
          display: none;
        }
      }
    }

    .el-menu-item-group__title {
      padding: 15px 0 0px 20px;
      color: transparentize($text-color, 0.65);
    }
  }

  .el-submenu__title,
  .el-menu-item:not(.is-active) {
    // color:#81C6E8;
    color: $text-color;

    i {
      color: $text-color;
    }
  }

  &.el-menu--collapse {
    .el-menu-item-group__title {
      padding: 15px 0 0px 0px;
      width: 100%;
      text-align: center;
    }

    .el-submenu__title:hover,
    .el-menu-item:hover {
      background-color: rgba(0, 0, 0, 0.05) !important;
    }
  }

  &.el-menu--horizontal {
    white-space: nowrap;
    /*width: fit-content;
		width: max-content;*/
    overflow: hidden;
    display: table;

    & > * {
      float: inherit !important;
      display: inline-block;
    }
  }

  &.nav-collapsed {
    .el-menu-item,
    .el-submenu__title {
      & > span {
        display: none;
      }
    }
  }
}

.main-navigation-submenu {
  .el-menu {
    background: #fff !important;

    .el-menu-item:not(.is-active) {
      color: $text-color;
      color: #81c6e8;
    }
    .el-menu-item:hover {
      background-color: transparentize($background-color, 0.3) !important;
    }
  }
}
</style>
